// src/utils/dateFormatter.js

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc"
export const formatDate = (isoString) => {
    const date = new Date(isoString);
    const day = date.getDate();
    const month = date.toLocaleString("en-US", { month: "short" }); // May, Jun, etc.
    const year = date.getFullYear();
    return `${day}${month}${year}`;
  };


;
dayjs.extend(utc);
export const toBackendDateFormat = (date) => {
  return dayjs(date).utc().format("YYYY-MM-DDTHH:mm:ss.SSS") + "000";
};